@if (m_show) {
    @if (!miniButton) {
        @if (iconButton) {
            <a mat-icon-button>
                <ng-container *ngTemplateOutlet="linkTemplate"></ng-container>
            </a>
        }
        @if (!iconButton) {
            <a mat-button class="buttonBarButt">
                <ng-container *ngTemplateOutlet="linkTemplate"></ng-container>
            </a>
        }
    }
    @if (miniButton) {
        <a>
            <ng-container *ngTemplateOutlet="linkTemplate"></ng-container>
        </a>
    }
}


<ng-template #linkTemplate>
    <div (click)="openDialogVideo($event)" matTooltip="{{m_toolTip | transloco}}">
        @if (showBalloon && !watched) {
            <span class="balloon">Start here</span>
        }
        <mat-icon [ngClass]="{'blinking': blinking}"  (animationend)="onAnimationEnd()">school</mat-icon>
    </div>
</ng-template>
